__turbopack_context__.v({
  "spin": "qoHLWq_spin",
  "spinner": "qoHLWq_spinner",
});
